// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article-box-data {
  background-color: rgba(0, 0, 0, 0) !important;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 25px;
  padding-left: 25px;
  padding-right: 25px;
  margin-right: 0px;
  margin-left: 0px;
}

.article-picture {
  width: 100%;
  max-height: 350px;
  margin-bottom: 25px;
}

.link-box {
  color: black;
  text-decoration: none !important;
}

.link-box:hover {
  color: black;
  text-decoration: none !important;
}

.article-box {
  background-color: rgba(0, 0, 0, 0) !important;
  flex: 1 1;
  align-items: flex-start;
  align-content: flex-start;
}
.article-box h3 {
  align-self: flex-start !important;
  text-align: left !important;
  padding: 0px !important;
}
.article-box .by-author {
  align-self: flex-start !important;
  text-align: left !important;
  padding: 0px !important;
}

.article-detail {
  background-color: #ffffff !important;
  min-width: 25em;
  border-radius: 25px;
  margin-right: 10px;
  margin-bottom: 10px;
  font-size: 15px;
  font-family: "Lato", sans-serif !important;
  padding: 50px;
  margin-left: 1rem;
}
.article-detail h3 {
  margin-bottom: 25px;
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-weight: 500;
  font-size: 30px;
  letter-spacing: 0px;
  color: #1a1919;
}
.article-detail h5 {
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  margin-bottom: 25px;
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-size: 14px/24px;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
}
.article-detail b {
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-size: 14px/24px;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
}
.article-detail h6 {
  margin-bottom: 25px;
}
.article-detail p {
  font-size: 16px;
}
.article-detail li {
  font-size: 16px !important;
}
.more-articles {
  background-color: rgba(0, 0, 0, 0) !important;
  width: 45%;
  align-self: flex-start;
  border-radius: 25px;
  margin-bottom: 10px;
  min-width: 20em;
}

.box-more {
  background-color: rgba(0, 0, 0, 0);
  padding: 5px;
  margin: 5px;
  margin-top: 20px;
  font-size: 25px;
  font-family: "Lato", sans-serif !important;
  align-self: flex-start;
}

.box-data {
  background-color: rgba(137, 1, 53, 0.05);
  padding: 35px;
  margin: 10px;
  border-radius: 5px;
  font-size: 15px;
  font-family: "Lato", sans-serif !important;
}

.article-preview {
  flex-direction: column;
  justify-content: center;
  width: 100%;
  background-color: rgb(255, 255, 255);
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 30px;
  margin-bottom: 25px;
  cursor: pointer;
}

.article-img-preview {
  width: 100%;
  max-height: 350px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.container-img-article {
  width: 100%;
  max-height: 350px;
  margin-bottom: 25px;
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/sass/layout/articleContainer/articleContainer.scss","webpack://./src/sass/layout/articleContainer/articleContainer.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAGA;EACE,6CAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;ACFF;;ADKA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;ACFF;;ADKA;EACE,YAAA;EACA,gCAAA;ACFF;;ADKA;EACE,YAAA;EACA,gCAAA;ACFF;;ADKA;EACE,6CAAA;EACA,SAAA;EACA,uBAAA;EACA,yBAAA;ACFF;ADIE;EACE,iCAAA;EACA,2BAAA;EACA,uBAAA;ACFJ;ADKE;EACE,iCAAA;EACA,2BAAA;EACA,uBAAA;ACHJ;;ADOA;EACE,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,0CEtDK;EFuDL,aAAA;EACA,iBAAA;ACJF;ADKE;EACE,mBAAA;EACA,gBAAA;EACA,0CE5DG;EF6DH,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;ACHJ;ADME;EACE,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CE1EG;EF2EH,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;ACJJ;ADOE;EACE,gBAAA;EACA,0CEnFG;EFoFH,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;ACLJ;ADQE;EACE,mBAAA;ACNJ;ADSE;EACE,eAAA;ACPJ;AACA;EDUA,0BAAA;ACRA;AACA;EDUE,6CAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;ECRF,mBAAA;EACE,eAAe;ADUjB;;ACPA;EDUE,kCAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;ECRF,0CAAA;EACE,sBAAsB;ADUxB;;ACPA;EDUE,wCAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;ECRF,eAAA;EACE,0CAA0C;ADU5C;;ACPA;EDUE,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,oCAAA;EACA,+BAAA;EACA,gCAAA;EACA,aAAA;ECRF,mBAAA;EACE,eAAe;ADUjB;;ACPA;EDUE,WAAA;EACA,iBAAA;ECRF,4BAAA;EACE,6BAA6B;ADU/B;;ACPA;EDUE,WAAA;EACA,iBAAA;ECRF,mBAAA;EACE,qBAAqB;AACvB","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.article-box-data {\n  background-color: $Transparent !important;\n  flex-direction: column;\n  justify-content: flex-start;\n  margin-bottom: 25px;\n  padding-left: 25px;\n  padding-right: 25px;\n  margin-right: 0px;\n  margin-left: 0px;\n}\n\n.article-picture {\n  width: 100%;\n  max-height: 350px;\n  margin-bottom: 25px;\n}\n\n.link-box {\n  color: black;\n  text-decoration: none !important;\n}\n\n.link-box:hover {\n  color: black;\n  text-decoration: none !important;\n}\n\n.article-box {\n  background-color: $Transparent !important;\n  flex: 1;\n  align-items: flex-start;\n  align-content: flex-start;\n\n  h3 {\n    align-self: flex-start !important;\n    text-align: left !important;\n    padding: 0px !important;\n  }\n\n  .by-author {\n    align-self: flex-start !important;\n    text-align: left !important;\n    padding: 0px !important;\n  }\n}\n\n.article-detail {\n  background-color: #ffffff !important;\n  min-width: 25em;\n  border-radius: 25px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n  font-size: 15px;\n  font-family: $Font;\n  padding: 50px;\n  margin-left: 1rem;\n  h3 {\n    margin-bottom: 25px;\n    text-align: left;\n    font-family: $Font;\n    font-weight: 500;\n    font-size: 30px;\n    letter-spacing: 0px;\n    color: #1a1919;\n  }\n\n  h5 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n    margin-bottom: 25px;\n    text-align: left;\n    font-family: $Font;\n    font-size: 14px/24px;\n    letter-spacing: 0px;\n    color: #1a1919;\n    opacity: 1;\n  }\n\n  b {\n    text-align: left;\n    font-family: $Font;\n    font-size: 14px/24px;\n    letter-spacing: 0px;\n    color: #1a1919;\n    opacity: 1;\n  }\n\n  h6 {\n    margin-bottom: 25px;\n  }\n\n  p {\n    font-size: 16px;\n  }\n  li {\n    font-size: 16px !important;\n  }\n}\n\n.more-articles {\n  background-color: rgb(0, 0, 0, 0) !important;\n  width: 45%;\n  align-self: flex-start;\n  border-radius: 25px;\n  margin-bottom: 10px;\n  min-width: 20em;\n}\n\n.box-more {\n  background-color: rgb(0, 0, 0, 0);\n  padding: 5px;\n  margin: 5px;\n  margin-top: 20px;\n  font-size: 25px;\n  font-family: $Font;\n  align-self: flex-start;\n}\n\n.box-data {\n  background-color: rgba(137, 1, 53, 0.05);\n  padding: 35px;\n  margin: 10px;\n  border-radius: 5px;\n  font-size: 15px;\n  font-family: $Font;\n}\n\n.article-preview {\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  background-color: rgba(255, 255, 255, 1);\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n  padding: 30px;\n  margin-bottom: 25px;\n  cursor: pointer;\n}\n\n.article-img-preview {\n  width: 100%;\n  max-height: 350px;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n}\n\n.container-img-article {\n  width: 100%;\n  max-height: 350px;\n  margin-bottom: 25px;\n  padding: 0 !important;\n}\n",".article-box-data {\n  background-color: rgba(0, 0, 0, 0) !important;\n  flex-direction: column;\n  justify-content: flex-start;\n  margin-bottom: 25px;\n  padding-left: 25px;\n  padding-right: 25px;\n  margin-right: 0px;\n  margin-left: 0px;\n}\n\n.article-picture {\n  width: 100%;\n  max-height: 350px;\n  margin-bottom: 25px;\n}\n\n.link-box {\n  color: black;\n  text-decoration: none !important;\n}\n\n.link-box:hover {\n  color: black;\n  text-decoration: none !important;\n}\n\n.article-box {\n  background-color: rgba(0, 0, 0, 0) !important;\n  flex: 1;\n  align-items: flex-start;\n  align-content: flex-start;\n}\n.article-box h3 {\n  align-self: flex-start !important;\n  text-align: left !important;\n  padding: 0px !important;\n}\n.article-box .by-author {\n  align-self: flex-start !important;\n  text-align: left !important;\n  padding: 0px !important;\n}\n\n.article-detail {\n  background-color: #ffffff !important;\n  min-width: 25em;\n  border-radius: 25px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n  font-size: 15px;\n  font-family: \"Lato\", sans-serif !important;\n  padding: 50px;\n  margin-left: 1rem;\n}\n.article-detail h3 {\n  margin-bottom: 25px;\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-weight: 500;\n  font-size: 30px;\n  letter-spacing: 0px;\n  color: #1a1919;\n}\n.article-detail h5 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n  margin-bottom: 25px;\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 14px/24px;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n}\n.article-detail b {\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 14px/24px;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n}\n.article-detail h6 {\n  margin-bottom: 25px;\n}\n.article-detail p {\n  font-size: 16px;\n}\n.article-detail li {\n  font-size: 16px !important;\n}\n.more-articles {\n  background-color: rgba(0, 0, 0, 0) !important;\n  width: 45%;\n  align-self: flex-start;\n  border-radius: 25px;\n  margin-bottom: 10px;\n  min-width: 20em;\n}\n\n.box-more {\n  background-color: rgba(0, 0, 0, 0);\n  padding: 5px;\n  margin: 5px;\n  margin-top: 20px;\n  font-size: 25px;\n  font-family: \"Lato\", sans-serif !important;\n  align-self: flex-start;\n}\n\n.box-data {\n  background-color: rgba(137, 1, 53, 0.05);\n  padding: 35px;\n  margin: 10px;\n  border-radius: 5px;\n  font-size: 15px;\n  font-family: \"Lato\", sans-serif !important;\n}\n\n.article-preview {\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  background-color: rgb(255, 255, 255);\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n  padding: 30px;\n  margin-bottom: 25px;\n  cursor: pointer;\n}\n\n.article-img-preview {\n  width: 100%;\n  max-height: 350px;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n}\n\n.container-img-article {\n  width: 100%;\n  max-height: 350px;\n  margin-bottom: 25px;\n  padding: 0 !important;\n}/*# sourceMappingURL=articleContainer.css.map */","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
